import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="30" height="28" viewBox="0 0 30 28" xmlns="http://www.w3.org/2000/svg" {...this.props}><g fill="none" fillRule="evenodd"><path d="M14.609 4.222L18.704.127a.435.435 0 1 1 .614.615l-4.212 4.212a.65.65 0 0 1-1.112.497l-2.803-2.803a.652.652 0 1 1 .922-.922l2.496 2.496z" fill="#3899EC" fillRule="nonzero" /><rect fill="#7FCCF7" y="6" width="30" height="22" rx="2" /><path d="M20.87 7.804c0 2.102-2.433 3.805-5.434 3.805-3.002 0-5.436-1.703-5.436-3.805C10 5.703 12.434 4 15.436 4c3.001 0 5.435 1.703 5.435 3.804" fill="#7FCCF7" /><path fill="#FFF" d="M5 23.387h17.391V11H5zm22.255-11.26a1.127 1.127 0 1 1-2.255 0 1.127 1.127 0 0 1 2.255 0m0 4a1.127 1.127 0 1 1-2.255 0 1.127 1.127 0 0 1 2.255 0" /><path fill="#3899EC" d="M12 15l3.84 2.351-3.826 2.376z" /></g></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/channel.svg